import { ApiCategory } from "../api/types/api-category";
import { ApiTheme } from "../api/types/api-theme";
import React from "react";
import { CategoryWithThemes } from "../pages/tagging/types";

const emptyData: CategoryWithThemes[] = [];

export const useCategoriesWithThemes = (
  categories?: ApiCategory[],
  themes?: ApiTheme[]
): CategoryWithThemes[] => {
  return React.useMemo(() => {
    if (!categories || !themes) {
      return emptyData;
    }

    return [...categories]
      .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name))
      .map((category) => {
        return {
          ...category,
          themes: themes
            .filter(
              (theme) => theme.relationships.category.data.id === category.id
            )
            .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name)),
        };
      });
  }, [categories, themes]);
};
